import {
  Alert,
  Box,
  Button,
  Chip,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ContentTitleBar } from "../../../components/ContentTitleBar";
import {
  checkStatusWhitelist,
  getNavigationUrl,
} from "../../../store/navigationUtil";
import { ClipTitleBarMenu } from "../../../components/titleBarMenu/ClipTitleBarMenu";
import { GlimpseErrorOutput } from "./GlimpseErrorOutput";
import { loadClip } from "../utils/dataLoader";
import { canEditClip } from "../../../store/AclUtil";
import { useAuth } from "../../../store/auth/hooks";
import { HistoryDrawer } from "../../../components/HistoryDrawer";

export const GlimpseErrorPage = () => {
  const navigate = useNavigate();
  const { caseId, clipId } = useParams();
  const { user } = useAuth();
  const [clip, setClip] = useState(null);
  const [readOnly, setReadOnly] = useState(true);

  const load = useCallback(async () => {
    const currClip = await loadClip(caseId, clipId);
    if (!currClip) {
      navigate(getNavigationUrl(caseId));
    }
    if (!checkStatusWhitelist(currClip, "GLIMPSE_ERROR")) {
      navigate(getNavigationUrl(caseId, currClip));
    }
    setClip(currClip);
    setReadOnly(!canEditClip(user, currClip));
  }, [caseId, clipId, navigate, user]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Stack component="main" height={1}>
      <Stack flex={1} p={2} height={1}>
        <Paper elevation={4} sx={{ p: 2, mb: 2 }}>
          <Grid container rowSpacing={2} columnSpacing={4}>
            <Grid
              size={{ xs: 12, sm: 3, md: 2 }}
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              maxWidth="fit-content"
            >
              <Typography variant="caption">STATUS</Typography>
              <Chip color="error" label="GLIMPSE Error" />
            </Grid>
            <Grid
              size={{ xs: 12, sm: 9, md: 10 }}
              display="flex"
              alignItems="center"
              maxWidth={560}
            >
              <Alert severity="error">
                GLIMPSE encountered an error. Please review the error log below.
                You can delete the clip or roll it back to a previous state
                using "VIEW CLIP HISTORY"
              </Alert>
            </Grid>
          </Grid>
        </Paper>
        <GlimpseErrorOutput caseId={caseId} clipId={clipId} />
      </Stack>
      <Paper
        elevation={4}
        sx={{
          p: 1,
          mx: 1,
          mb: 1,
        }}
      >
        <Button
          variant="outlined"
          onClick={async () => navigate(getNavigationUrl(caseId))}
        >
          RETURN TO CLIPS
        </Button>
      </Paper>
      <ContentTitleBar
        menu={
          clip && (
            <ClipTitleBarMenu
              user={user}
              clip={clip}
              readOnly={readOnly}
              color="light"
            />
          )
        }
        name={clip?.description}
        label="Clip Error"
      />
      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          zIndex: (theme) => theme.zIndex.drawer,
        }}
      >
        <HistoryDrawer caseId={caseId} clipId={clipId} page="glimpseError" />
      </Box>
    </Stack>
  );
};
